import { NotificationsAction, NotificationsState } from 'types/notifications';
import { initialState } from './index';

export function notificationsReducer(
  state: NotificationsState = initialState.notifications,
  action: NotificationsAction,
): NotificationsState {
  switch (action.type) {
    case 'Notifications.SnackbarEnqueued':
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            key: action.payload.notification.key,
            ...action.payload.notification,
          },
        ],
      };

    case 'Notifications.SnackbarClosed':
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          action.payload.dismissAll || notification.key === action.payload.key
            ? { ...notification, dismissed: true }
            : { ...notification },
        ),
      };

    case 'Notifications.SnackbarRemoved':
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.key !== action.payload.key,
        ),
      };

    default:
      return state;
  }
}
